































import { Component, Prop, Watch } from 'vue-property-decorator';
import { CardForm, DialogForm } from '@/components/bwaff';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';
import DetailsSubscriptionLimitsBlock from '@/views/settings/subscription/forms/details-subscription-limits/details-subscription-limits-block.vue';
import _ from 'lodash';

@Component({
  components: {
    CardForm,
    DialogForm,
    DetailsSubscriptionLimitsBlock
  }
})
export default class Details extends mixins<PlanLimitsMixin>(PlanLimitsMixin) {
  @Prop()
  api: any;
  search='';
  filteredPlanLimitsKeysGrouping = [];
  debouncedPlanLimitsKeysGrouping = null

  created() {
    this.filteredPlanLimitsKeysGrouping = this.sortPlanLimitsGrouping(this.planLimitsKeysGrouping);
    this.debouncedPlanLimitsKeysGrouping=_.debounce(this.filterPlanLimitsGrouping,500)
  }

  sortPlanLimitsGrouping(grouping) {
    return grouping.map(group => ({
      ...group,
      keys: [...group.keys].sort((a, b) =>
        this.planLimitsKeyTextShort[a].localeCompare(
          this.planLimitsKeyTextShort[b],
          undefined,
          { sensitivity: 'base' }
        )
      )
    }));
  }

  filterPlanLimitsGrouping() { 
    this.filteredPlanLimitsKeysGrouping = this.sortPlanLimitsGrouping(
      this.planLimitsKeysGrouping.reduce((acc, group) => {
        const filteredKeys = group.keys.filter(key => {
          return this.planLimitsKeyTextShort[key].toLowerCase().includes(this.search.toLowerCase())
        })
        const isFoundInName = group.name.toLowerCase().includes(this.search.toLowerCase())

        if (filteredKeys.length || isFoundInName) {
          acc.push({
            ...group,
            keys: isFoundInName ? group.keys : filteredKeys
          })
        }

        return acc
      }, [])
    )
  }

  @Watch('search')
  onSearchChanged() {
    this.debouncedPlanLimitsKeysGrouping()
  }
}
